module.exports = __webpack_public_path__ + "static/media/mucihAbout.b74a7b79.png";